'use client';

import type AccountTheme from '@hub/common/src/AccountTheme';
import { CitOrigin } from '@hub/common/src/types/cit-public-api';

import ChangeBodyBackgroundColor from './ChangeBodyBackgroundColor';
import CatalogItIcon from './SVG/CatalogItIcon';

const ICON_SIZE = 100;

export default function ErrorMessage({
  message,
  subTitle,
  citOrigin,
  accountTheme
}: {
  message: string;
  subTitle?: string;
  citOrigin: CitOrigin;
  accountTheme?: AccountTheme;
}) {
  const theme = citOrigin === CitOrigin.HUBPRO ? accountTheme : undefined;

  const titleStyle = theme
    ? {
        color: theme.titleFontColor(),
        fontFamily: theme.titleFont(),
        lineHeight: theme.lineHeight(),
        letterSpacing: theme.letterSpacing()
      }
    : undefined;

  const subTitleStyle = theme
    ? {
        color: theme.bodyFontColor(),
        fontFamily: theme.bodyFont(),
        lineHeight: theme.lineHeight(),
        letterSpacing: theme.letterSpacing()
      }
    : undefined;

  const buttonStyle = theme
    ? {
        backgroundColor: theme.headerBackgroundColor(),
        color: theme.headerFontColor(),
        fontFamily: theme.headerFont()
      }
    : { backgroundColor: '#005F91', color: '#FFFFFF' };

  const iconURL = theme?.iconURL();

  return (
    <div className='flex flex-col items-center h-full gap-6 mt-20'>
      {theme ? <ChangeBodyBackgroundColor color={theme.backgroundColor(undefined, true)} /> : null}

      {citOrigin !== CitOrigin.HUBPRO ? <CatalogItIcon size={ICON_SIZE} /> : null}

      {theme && iconURL ? (
        <img
          src={iconURL}
          alt={`${theme.accountName()} logo`}
          width={ICON_SIZE}
          height={ICON_SIZE}
          className='rounded-full object-cover'
          style={{ aspectRatio: '1 / 1', margin: 12 }}
        />
      ) : null}

      <h1 className='text-4xl font-bold text-center' style={titleStyle}>
        {message}
      </h1>
      {subTitle && (
        <h2 className='text-xl text-center' style={subTitleStyle}>
          {subTitle}
        </h2>
      )}

      <button
        onClick={() => {
          window.location.href = '/';
        }}
        className='px-4 py-2 rounded-md text-xl cursor-pointer'
        style={buttonStyle}
      >
        Continue
      </button>
    </div>
  );
}
